import React, { useEffect, useState } from 'react';
import { Keyboard } from 'lucide-react';

export function CommandPaletteHint() {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const id = setTimeout(() => setShow(false), 6500);
    return () => clearTimeout(id);
  }, []);
  if (!show) return null;
  return (
    <div className="pointer-events-none fixed bottom-10 left-1/2 z-50 -translate-x-1/2 animate-fade-in rounded-md border border-border bg-popover/95 px-3 py-1.5 text-[11px] text-muted-foreground backdrop-blur-sm shadow-panel">
      <span className="inline-flex items-center gap-2">
        <Keyboard className="h-3 w-3" />
        Drag any panel header to rearrange the workspace · <kbd className="rounded border border-border bg-background px-1.5 py-0.5 font-mono-stat text-[10px]">Ctrl</kbd> <kbd className="rounded border border-border bg-background px-1.5 py-0.5 font-mono-stat text-[10px]">K</kbd> command palette
      </span>
    </div>
  );
}
